import useDefaultInputStyles from "../../hooks/useDefaultInputStyles";
import React, { forwardRef } from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    rightElement?: () => React.ReactNode
    darkStyle?: boolean,
    contrastStyle?: boolean,
    refStyle?: boolean,
    grayStyle?: boolean,
    grayBorderedStyle?: boolean,
    labeled?: boolean,
    wrapperStyle?: string,
    rightElementStyle?: string
}

const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {

    const { rightElement, wrapperStyle, rightElementStyle, ...inputProps } = props
    const styledProps = useDefaultInputStyles(inputProps as any);

    const styleWrapper = wrapperStyle ? wrapperStyle : 'input_wrapper'
    const styleRightElement = rightElementStyle ? rightElementStyle : 'input_right-element'

    return (
        <div className={styleWrapper}>
            <input {...styledProps} ref={ref} />

            {rightElement && (
                <div className={styleRightElement}>
                    {rightElement()}
                </div>
            )}
        </div>
    )

})

export default Input;